import { createStreamListener, useStream } from '../../socket/use-stream';
import { useCurrentUser } from '../../current-user/current-user';
import { useOpenEventPanel } from '../use-open-event-panel';
import { useMemo } from 'react';

export function ProQaPanelActionsProvider() {
    const currentUser = useCurrentUser();
    const openEventPanel = useOpenEventPanel();

    const streamListener = useMemo(
        () =>
            createStreamListener({
                streamNames: ['proqa'] as const,
                onMessage(message) {
                    const proQaEvent = message.payload;
                    if (
                        proQaEvent.actingUserId !== currentUser.userId ||
                        proQaEvent.action !== 'OPEN_SECONDARY_EVENT_PANELS'
                    ) {
                        return;
                    }
                    const eventIds = proQaEvent.metadata.eventIds;
                    if (!Array.isArray(eventIds)) {
                        return;
                    }

                    const shouldFocusPanelValue = proQaEvent.metadata.shouldFocusPanel;
                    const shouldFocusPanel =
                        typeof shouldFocusPanelValue === 'boolean' ? shouldFocusPanelValue : true;

                    eventIds.forEach((eventId) => {
                        if (typeof eventId !== 'number') {
                            return;
                        }
                        openEventPanel({ eventId, shouldFocusPanel });
                    });
                },
            }),
        [currentUser.userId, openEventPanel]
    );

    useStream(streamListener);

    return <></>;
}
